import React, { ReactNode } from 'react';

interface Props {
  /**
   * Will be rendered when the location requirements are met
   */
  children?: ReactNode;
  /**
   * If set, the location requirement is inverted
   */
  not?: boolean;
  /**
   * Requires that the 'pathname' segment of the location equals this value
   */
  pathname: string;
}

const initialLocation = {
  pathname: window.location.pathname,
};

/**
 * Renders children only when properties of the initial page load window location meet given specifications
 *
 * @todo Add support for other parts of location being matched besides pathname
 * @todo Add support for the same router pattern matching as react-router
 * @todo Add support for using a different window or location object
 */
const RequireLocation = (props: Props) => {
  const isMatch = props.not ? initialLocation.pathname !== props.pathname : initialLocation.pathname === props.pathname;

  return <>{isMatch && props.children ? props.children : null}</>;
};

export default RequireLocation;
